import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

function SupervisorHome() {
  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col md="8" lg="6">
          <Card className="rounded-4">
            <CardBody className="text-center p-4">
              <img
                style={{
                  width: "5rem",
                  height: "5rem",
                  borderRadius: "0.6rem",
                }}
                alt="APL by LearnWARE app icon"
                src={"img/AppIcon.png"}
              />
              <h5 className="mt-2">
                <FormattedMessage id="APLAppName" />
              </h5>
              <h3 className="mt-3 mb-3">
                <FormattedMessage id="Views.SupervisorHome.Welcome" />
              </h3>
              <p>
                <FormattedMessage id="Views.SupervisorHome.Intro" />
              </p>
              <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                <a href="https://play.google.com/store/apps/details?id=com.aplBy.learnware">
                  <img
                    style={{ borderRadius: "0.6rem", height: "2.5rem" }}
                    alt="Link to app in playstore"
                    src={"img/googleplay-img.png"}
                  />
                </a>
                <a href="https://apps.apple.com/se/app/apl-by-learnware/id1629042752">
                  <img
                    style={{ borderRadius: "0.6rem", height: "2.5rem" }}
                    alt="Link to app in appstore"
                    src={"img/appstore-img.png"}
                  />
                </a>
              </div>
              <hr className="my-4" />
              <div>
                <p>
                  <FormattedMessage id="Views.SupervisorHome.SupportText" />
                </p>
                <div className="d-flex justify-content-center align-items-center mb-1">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-primary" />
                  <span>0451-74 44 00</span>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary" />
                  <span>support@pol.se</span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default SupervisorHome;
